import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { GenericError } from '@cian/peperrors/shared';
export var ResponseError = /*#__PURE__*/function (_GenericError) {
  _inherits(ResponseError, _GenericError);
  var _super = _createSuper(ResponseError);
  /* istanbul ignore next */
  function ResponseError(_ref) {
    var _this;
    var domain = _ref.domain,
      message = _ref.message,
      details = _ref.details;
    _classCallCheck(this, ResponseError);
    _this = _super.call(this, {
      domain: domain,
      message: message,
      type: 'ResponseError',
      details: details
    });
    Object.setPrototypeOf(_assertThisInitialized(_this), ResponseError.prototype);
    return _this;
  }
  return _createClass(ResponseError);
}(GenericError);